import R from 'ramda'

export const togglePath = path => (obj) => R.assocPath(path, R.not(R.path(path, obj)), obj)

export const unionWithProp = (prop) => R.unionWith(R.eqProps(prop))

export const unionWithId = unionWithProp('id')

export const assocPathArray = (path, v, a) => {
  const propToLens = prop => { return R.type(prop) == "Number" ? R.lensIndex(prop) : R.lensProp(prop) }
  const lenses = R.map(propToLens, path)
  const teleObj = R.apply(R.compose, lenses)
  return R.set(teleObj, v, a)
}




/** WEBPACK FOOTER **
 ** ./app/utils/objUtils.js
 **/